import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, EventTriggers, Hidden } from '../../../Components/Form';
import { eventTriggers } from '../../../Data/Misc';

const ConfirmAppointments = ({isOpen, setIsOpen, confirming, confirmAppointments, refresh}) => {
    return <Modal title="Confirm schedule" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{day: confirming.day, week: confirming.week, confirmAppointments, refresh}} />}
    </Modal>
}

const Inner = ({confirmAppointments, day, week, refresh}) => {
    const data = day ? {date: day.date} : {week};

    return <Form data={data} onSubmit={confirmAppointments} afterSubmit={refresh} closeModalOnSubmit>
        <p>Are you sure you want to schedule all the jobs {day ? `on ${day.title}` : 'this week'}?</p>
        <Hidden name={day ? 'date' : 'week'} value={day ? day.date : week} />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit={{label: 'Confirm'}} cancel />
    </Form>
}

export default ConfirmAppointments;
